import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-c5f59a8c"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "d-flex fl-j-c fl-a-c picture-container"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  key: 1,
  class: "f-bold picture-placeholder"
};
var _hoisted_4 = {
  class: "d-flex flex-column fl-s-b details-container"
};
var _hoisted_5 = {
  class: "f-bold name"
};
var _hoisted_6 = {
  class: "code"
};
var _hoisted_7 = {
  class: "f-bold value"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["campaigns-card d-flex", {
      'active-card': _ctx.data.isApplied
    }]),
    "data-cy": "promo-campaign-card"
  }, [_createElementVNode("div", _hoisted_1, [_ctx.data.picture ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: _ctx.data.picture
  }, null, 8, _hoisted_2)) : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.data.name.charAt(0)), 1))]), _createElementVNode("div", _hoisted_4, [_createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.data.name), 1), _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.data.code), 1), _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.data.flatValue ? (_ctx.data.flatValue / 100).toFixed(2) : "".concat(_ctx.data.percentageValue, "%")), 1)])], 2);
}